module.exports = __webpack_public_path__ + "static/Glober_xBold-03ce4321a9ad2c69cfc9299b2f7544ad.ttf";